import { Component, ReactNode } from 'react';

class CustomDismissible extends Component<Props> {
  public render() {
    const { children } = this.props;
    return children;
  }

  public componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  private handleOutsideClick = (e: MouseEvent) => {
    const doc = document.getElementById(this.props.id);
    if (doc == undefined) return;

    const selection = window.getSelection();
    if (selection && selection.toString().length > 0) {
      return;
    }

    const isNotDismissible = e
      .composedPath()
      .filter((p) => p instanceof HTMLElement)
      .some((p) => (p as HTMLElement).classList.contains('not-dismissable'));
    const isOutside = !e.composedPath().includes(doc);
    if (isOutside && !isNotDismissible) {
      this.props.onDismiss();
    }
  };
}

interface Props {
  children?: ReactNode;
  id: string;
  onDismiss: () => void;
}

export default CustomDismissible;
